module.exports = __webpack_public_path__ + "img/79.74471459.png";